/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21lbWJlcnMvZGV0YWlscy1wYWdlL21lbWJlcnMtYXRobGV0ZXMvYm9vdHN0cmFwLW1lbWJlcnMtYXRobGV0ZXMvYm9vdHN0cmFwLW1lbWJlcnMtYXRobGV0ZXMuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
